import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';

import styles from 'views/component/Styles.js';

import SimpleTable from 'views/component/SimpleTable.js';

const useStyles = makeStyles(styles);

export default function ProductionPlan(props) {
    const { factory, onSave, operationSelect } = props;
    const classes = useStyles();
    const [selectForm, setSelectForm] = useState({});

    useEffect(() => {
        setSelectForm(operationSelect);
    }, [operationSelect])

    const handleSave = function (tempData) {
        if (onSave) {
            onSave(tempData);
        }
    }
    const handleAdd = function (prev, row) {
        row['job_id'] = (prev.length + 1) + '. JOB';
        return row;
    }
    return (<GridItem xs={12} md={6} className={classes.collapsed}>
        <div className={classes.cellTitle}>
            <h4>Production Plan</h4>
        </div>
        <div className={classes.cellContentAps}>
            <SimpleTable domain="aps" tableName="productionPlan" params={factory} insertAttr={factory} onSave={handleSave}
                selectForm={selectForm} onAdd={handleAdd} droppable />
        </div>
    </GridItem>);
}